import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {FileUploader as DXFileUploader} from 'devextreme-react';


export default class FileUploader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
            disabled: this.props.disabled,
            value: this.props.value,
        };

        this.onValueChanged = this.onValueChanged.bind(this);
        this.onUploaded = this.onUploaded.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            visible: props.visible,
            disabled: props.disabled,
        });
    }

    onValueChanged(e) {
        console.log('onValueChanged', e)

        if (e.value.length) {
            this.setState({
                value: [...this.state.value, e.value[0]]
            })
        }
    }

    onUploaded(e) {
        console.log('onUploaded', e)
    }



    render() {
        return (
            <DXFileUploader
                {...omit(['loading_state', 'setProps'], this.props)}
                value={this.state.value}
                onValueChanged={this.props.onValueChanged || this.onValueChanged}
                onUploaded={this.props.onUploaded || this.onUploaded}
            />
        );
    }

}

FileUploader.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * A function that cancels the file upload
     */
    abortUpload: PropTypes.func,
    /**
     * Specifies a file type or several types accepted by the UI component
     */
    accept: PropTypes.string,
    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Specifies if an end user can remove a file from the selection and interrupt uploading
     */
    allowCanceling: PropTypes.bool,
    /**
     * Restricts file extensions that can be uploaded to the server
     */
    allowedFileExtensions: PropTypes.arrayOf(PropTypes.string),
    /**
     * Specifies the chunk size in bytes. Applies only if uploadMode is "instantly" or "useButtons". Requires a server that can process file chunks.
     */
    chunkSize: PropTypes.number,
    /**
     * Specifies the HTML element which invokes the file upload dialog
     */
    dialogTrigger: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the HTML element in which users can drag and drop files for upload
     */
    dropZone: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies the attributes to be passed on to the underlying <input> element of the file type
     */
    inputAttr: PropTypes.object,
    /**
     * The text displayed when the extension of the file being uploaded is not an allowed file extension
     */
    invalidFileExtensionMessage: PropTypes.string,
    /**
     * The text displayed when the size of the file being uploaded is greater than the maxFileSize
     */
    invalidMaxFileSizeMessage: PropTypes.string,
    /**
     * The text displayed when the size of the file being uploaded is less than the minFileSize
     */
    invalidMinFileSizeMessage: PropTypes.string,
    /**
     * Specifies or indicates whether the editor's value is valid
     */
    isValid: PropTypes.bool,
    /**
     * Specifies the text displayed on the area to which an end-user can drop a file
     */
    labelText: PropTypes.string,
    /**
     * Specifies the maximum file size (in bytes) allowed for uploading. Applies only if uploadMode is "instantly" or "useButtons".
     */
    maxFileSize: PropTypes.number,
    /**
     * Specifies the minimum file size (in bytes) allowed for uploading. Applies only if uploadMode is "instantly" or "useButtons".
     */
    minFileSize: PropTypes.number,
    /**
     * Specifies whether the UI component enables an end-user to select a single file or multiple files
     */
    multiple: PropTypes.bool,
    /**
     * Specifies the value passed to the name attribute of the underlying input element. Required to access uploaded files on the server
     */
    name: PropTypes.string,
    /**
     * A function that allows you to customize the request before it is sent to the server
     */
    onBeforeSend: PropTypes.func,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed when the mouse enters a drop zone while dragging a file
     */
    onDropZoneEnter: PropTypes.func,
    /**
     * A function that is executed when the mouse leaves a drop zone as it drags a file
     */
    onDropZoneLeave: PropTypes.func,
    /**
     * A function that is executed when all files are successfully uploaded
     */
    onFilesUploaded: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when a file segment is uploaded
     */
    onProgress: PropTypes.func,
    /**
     * A function that is executed when the file upload is aborted
     */
    onUploadAborted: PropTypes.func,
    /**
     * A function that is executed when a file is successfully uploaded
     */
    onUploaded: PropTypes.func,
    /**
     * A function that is executed when an error occurs during the file upload
     */
    onUploadError: PropTypes.func,
    /**
     * A function that is executed when the file upload is started
     */
    onUploadStarted: PropTypes.func,
    /**
     * A function that is executed when one or several files are added to or removed from the selection
     */
    onValueChanged: PropTypes.func,
    /**
     * Gets the current progress in percentages
     */
    progress: PropTypes.number,
    /**
     * Specifies whether the editor is read-only
     */
    readOnly: PropTypes.bool,
    /**
     * The message displayed by the UI component when it is ready to upload the specified files
     */
    readyToUploadMessage: PropTypes.string,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * The text displayed on the button that opens the file browser
     */
    selectButtonText: PropTypes.string,
    /**
     * Specifies whether or not the UI component displays the list of selected files
     */
    showFileList: PropTypes.bool,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * The message displayed by the UI component when the file upload is cancelled
     */
    uploadAbortedMessage: PropTypes.string,
    /**
     * The text displayed on the button that starts uploading
     */
    uploadButtonText: PropTypes.string,
    /**
     * A function that uploads a file in chunks
     */
    uploadChunk: PropTypes.func,
    /**
     * Specifies custom data for the upload request
     */
    uploadCustomData: PropTypes.object,
    /**
     * The message displayed by the UI component when uploading is finished
     */
    uploadedMessage: PropTypes.string,
    /**
     * The message displayed by the UI component on uploading failure
     */
    uploadFailedMessage: PropTypes.string,
    /**
     * A function that uploads a file
     */
    uploadFile: PropTypes.func,
    /**
     * Specifies headers for the upload request
     */
    uploadHeaders: PropTypes.object,
    /**
     * Specifies the method for the upload request
     */
    uploadMethod: PropTypes.oneOf(['POST', 'PUT']),
    /**
     * Specifies how the UI component uploads files
     */
    uploadMode: PropTypes.oneOf(['instantly', 'useButtons', 'useForm']),
    /**
     * Specifies a target Url for the upload request
     */
    uploadUrl: PropTypes.string,
    /**
     * Information on the broken validation rule. Contains the first item from the validationErrors array.
     */
    validationError: PropTypes.object,
    /**
     * An array of the validation rules that failed
     */
    validationErrors: PropTypes.arrayOf(PropTypes.object),
    /**
     * Indicates or specifies the current validation status
     */
    validationStatus: PropTypes.oneOf(['valid', 'invalid', 'pending']),
    /**
     * Specifies a File instance representing the selected file. Read-only when uploadMode is "useForm".
     */
    value: PropTypes.arrayOf(File),
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

FileUploader.defaultProps = {
    abortUpload: null,
    accept: '',
    accessKey: null,
    activeStateEnabled: false,
    allowCanceling: true,
    allowedFileExtensions: [],
    chunkSize: 0,
    // dialogTrigger: undefined,
    disabled: false,
    // dropZone: undefined,
    elementAttr: {},
    focusStateEnabled: true,
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: false,
    inputAttr: {},
    invalidFileExtensionMessage: 'File type is not allowed',
    invalidMaxFileSizeMessage: 'File is too large',
    invalidMinFileSizeMessage: 'File is too small',
    isValid: true,
    labelText: 'or Drop file here',
    maxFileSize: 0,
    minFileSize: 0,
    multiple: false,
    name: 'files[]',
    onBeforeSend: null,
    onContentReady: null,
    onDisposing: null,
    onDropZoneEnter: null,
    onDropZoneLeave: null,
    onFilesUploaded: null,
    onInitialized: null,
    onOptionChanged: null,
    onProgress: null,
    onUploadAborted: null,
    onUploaded: null,
    onUploadError: null,
    onUploadStarted: null,
    onValueChanged: null,
    progress: 0,
    readOnly: false,
    readyToUploadMessage: 'Ready to upload',
    rtlEnabled: false,
    selectButtonText: 'Select File',
    showFileList: true,
    tabIndex: 0,
    uploadAbortedMessage: 'Upload cancelled',
    uploadButtonText: 'Upload',
    uploadChunk: null,
    uploadCustomData: {},
    uploadedMessage: 'Uploaded',
    uploadFailedMessage: 'Upload failed',
    uploadFile: null,
    uploadHeaders: {},
    uploadMethod: 'POST',
    uploadMode: 'instantly',
    uploadUrl: '/',
    validationError: null,
    validationErrors: null,
    validationStatus: 'valid',
    value: [],
    visible: true,
    // width: undefined
};
